<template>
  <div class="anita-hammer slide">
    <HorizontalAnimation :animation="animation" :loop=false />
    <div class="horizontal-layout animated fadeIn delay-2s">
      <p class="store">STORE 0111</p>
      <h1>Anita Hammer</h1>
      <p>District 21 has experienced increased activity from a vanity stuffing crew. An APM at store 0111 reports the DL of a woman attempting to return stolen merchandise. API runs the suspect’s license number to identify her as <strong>Anita Hammer</strong> and link her to returns at <br/> two additional stores.</p>
    </div>
    <router-link to="/trivia-1">
      <NextButton />
    </router-link>
  </div>
</template>

<script>
import HorizontalAnimation from '@/components/HorizontalAnimation.vue'
import NextButton from '@/components/NextButton.vue'
import AnitaHammer from '@/assets/anita-hammer.js'

export default {
  name: 'anita-hammer',
  components: {
    HorizontalAnimation,
    NextButton
  },
  data() {
    return {
      animation: AnitaHammer
    }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
  .horizontal-layout {
    margin-top:0;
  }
</style>
